import { render, staticRenderFns } from "./PheAccessoriesCipriani.vue?vue&type=template&id=ba441b24&"
import script from "./PheAccessoriesCipriani.vue?vue&type=script&lang=js&"
export * from "./PheAccessoriesCipriani.vue?vue&type=script&lang=js&"
import style0 from "./PheAccessoriesCipriani.vue?vue&type=style&index=0&id=ba441b24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports